import fightcampBoxingBag from './includes/fightcamp-boxing-bag.js';
import fightcampGloves from './includes/fightcamp-gloves.js';
import consoleFourTrackers from './includes/console-four-trackers.js';
import fightcampQuickWraps from './includes/fightcamp-quick-wraps.js';
import fightcampAnkleWraps from './includes/fightcamp-ankle-wraps.js';
import fightcampHeartRateMonitor from './includes/fightcamp-heart-rate-monitor.js';

export default {
  title: 'The FightCamp package',
  pathId: 'fightcamp',
  description: 'Our most basic package includes just what you need to experience FightCamp. Track your progress, compete against others, and access our complete library of on-demand workouts.',
  shortDescription: 'Just What You Need to Experience FightCamp',
  testShopifyId: 'gid://shopify/Product/7820642484313',
  prodShopifyId: 'gid://shopify/Product/8701900620012',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/2000x1053/4d9082f6e7/fc-001-website-v2-shop-test-image.png',
    alt: 'Console with trackers',
  },
  includes: [
    fightcampBoxingBag,
    fightcampGloves,
    consoleFourTrackers,
    fightcampQuickWraps,
    fightcampAnkleWraps,
    fightcampHeartRateMonitor,
  ],
  includesBag: true,
  assets: [
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/9a207558e9/fc-living-room.jpg',
      alt: 'FightCamp Package',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/bc0d46e6ff/fc-punch.jpg',
      alt: 'FightCamp user punching free standing bag',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/95f35dd971/fc-partner-workout.jpg',
      alt: 'FightCamp partner workout',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
      alt: 'FightCamp quick wraps with trackers',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
      alt: 'Person working out with FightCamp',
    },
  ],
};
